export const RESTRICTED_SITE_ADMIN = 'restricted site admin';
export const SITE_ADMIN = 'site admin';
export const ORG_ADMIN = 'org admin';
export const CLIENT_ADMIN = 'client admin';
